var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react"; // @ts-ignore
import { setCampaignData, setPaymentModeData } from "../../services/functions";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import PagesHeader from "ah_utility/PagesHeader";
import { useDispatch } from "react-redux";
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { PlanView } from "./ui/view";
import { useNavigate } from "react-router-dom";
import { navigateBack, navigateNext } from "../../dataBase/stepProgress";
import { Steps } from "../../enum/steps";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { STEP_PLAN } from "../../const/catalog";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import usePlan from "./components/plan";
import { PlansHeader } from "./ui/header";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { plansClearData } from "../../store/plans/actions";
import { travelPremiums, travelPremiumsClearData, } from "../../store/travelPremiums/actions";
var STEP = STEP_PLAN;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKeyVariables = "afy-variables";
var lsVariables = new LocalStorageService(storageKeyVariables);
var Plan = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var storageKey = "afy-steps";
    var steps = useGetSteps();
    var localStorageService = new LocalStorageService(storageKey);
    var storageKeyActionFlags = "afy-action-flags";
    // const storageKeyActionFlags = "afy-steps";
    var lsActionFlags = new LocalStorageService(storageKeyActionFlags);
    var navigate = useNavigate();
    var clientId = React.useState(findParamInLocalStorage("clientId"))[0];
    /*Adiciona flag para validar, si se muestran los rangos de edad
     * en el detalle de los planes*/
    var flags = React.useState(lsActionFlags.getPageActionFlagsStored())[0];
    var _a = React.useState(false), enableAgeRange = _a[0], setEnabledAgeRange = _a[1];
    var _b = React.useState(false), enableShowExtra = _b[0], setEnableShowExtra = _b[1];
    var _c = React.useState([]), filtersQuotes = _c[0], setFiltersQuotes = _c[1];
    var _d = React.useState([]), rowsQuotes = _d[0], setRowsQuotes = _d[1];
    var _e = React.useState(""), selectedPlanId = _e[0], setSelectedPlanId = _e[1];
    var _f = React.useState(false), updating = _f[0], setUpdating = _f[1];
    var _g = React.useState(""), changedPlanId = _g[0], setChangedPlanId = _g[1];
    var _h = React.useState(false), error = _h[0], setError = _h[1];
    var _j = React.useState(""), helperText = _j[0], setHelperText = _j[1];
    var _k = useState(1), planPage = _k[0], setPlanPage = _k[1];
    var _l = useState(20), planLimit = _l[0], setPlanLimit = _l[1];
    var _m = useState(0), countPagination = _m[0], setCountPagination = _m[1];
    var _o = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _o[0], setSeeToast = _o[1];
    var _p = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToastAlertNext = _p[0], setSeeToastAlertNext = _p[1];
    var _q = React.useState(true), enable = _q[0], setEnable = _q[1];
    /*Polizas o cotizaciones*/
    var _r = React.useState(false), showModalQuotes = _r[0], setShowModalQuotes = _r[1];
    var onCloseModalQuotes = function () {
        setShowModalQuotes(false);
    };
    var _s = React.useState([]), extraInfoNames = _s[0], setExtraInfoNames = _s[1];
    var _t = React.useState([]), extraInfoNamesAut = _t[0], setExtraInfoNamesAut = _t[1];
    var _u = React.useState(1), page = _u[0], setPage = _u[1];
    var _v = React.useState(100), limit = _v[0], setLimit = _v[1];
    var _w = React.useState(false), isDetailClick = _w[0], setIsDetailClick = _w[1];
    var _x = React.useState(false), isSingleCompareClick = _x[0], setIsSingleCompareClick = _x[1];
    var _y = React.useState({ id: "", name: "", value: "" }), paymentModelSelected = _y[0], setPaymentModelSelected = _y[1];
    var _z = React.useState(), coverTypeSelected = _z[0], setCoverTypeSelected = _z[1];
    var _0 = React.useState({
        id: "",
    }), planSelected = _0[0], setPlanSelected = _0[1];
    var _1 = React.useState({
        id: "",
    }), planSelectedNextStep = _1[0], setPlanSelectedNextStep = _1[1];
    var _2 = React.useState([]), planSelectedCompare = _2[0], setPlanSelectedCompare = _2[1];
    var _3 = React.useState(false), showDetail = _3[0], setShowDetail = _3[1];
    var _4 = React.useState(false), showCompareDetail = _4[0], setShowCompareDetail = _4[1];
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var summary = useGetSummary();
    var _5 = useState([]), filters = _5[0], setFilters = _5[1];
    var _6 = React.useState(""), namePlan = _6[0], setNamePlan = _6[1];
    var _7 = React.useState([]), paymentMode = _7[0], setPaymentMode = _7[1];
    var _8 = React.useState(true), isInitialLoad = _8[0], setIsInitialLoad = _8[1];
    var campaignInfo = React.useState(findParamInLocalStorage("campaign"))[0];
    var insuranceType = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name)[0];
    var insurance = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name)[0];
    var _9 = React.useState(false), showDetails = _9[0], setShowDetails = _9[1];
    var _10 = React.useState([]), stepsData = _10[0], setStepsData = _10[1];
    var _11 = React.useState([]), breadCrumbs = _11[0], setBreadCrumbs = _11[1];
    var _12 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
            comparativeButtonDisabled: false,
        },
        data: [],
    }), plan = _12[0], setPlan = _12[1];
    var _13 = useSelectors(), responsePlans = _13.responsePlans, errorPlans = _13.errorPlans, loadingPlans = _13.loadingPlans, responsePaymentMode = _13.responsePaymentMode, errorPaymentMode = _13.errorPaymentMode, loadingPaymentMode = _13.loadingPaymentMode, responseAllQuote = _13.responseAllQuote, errorAllQuote = _13.errorAllQuote, loadingAllQuote = _13.loadingAllQuote, responseTravelPremiums = _13.responseTravelPremiums, errorTravelPremiums = _13.errorTravelPremiums, loadingTravelPremiums = _13.loadingTravelPremiums;
    console.log("Version 1.0.1");
    var _14 = useUI(navigateBack, STEP, navigate, setPlanPage, setPlanLimit, setShowDetails, setShowDetail, setShowCompareDetail, setShowModalQuotes, plan, setPlan, setNamePlan), onClickBack = _14.onClickBack, onChangePage = _14.onChangePage, onChangeRowsPerPage = _14.onChangeRowsPerPage, closeDetail = _14.closeDetail, onClickNewQuoteModal = _14.onClickNewQuoteModal, clickView = _14.clickView, searchFilter = _14.searchFilter;
    var _15 = usePlan(setRowsQuotes, planSelectedNextStep, setShowModalQuotes, navigate, projectId, enable, page, limit, planPage, planLimit, namePlan, paymentModelSelected, coverTypeSelected, clientId, plan, setPlan, setUpdating, changedPlanId, setPaymentModeData, paymentMode, setPaymentMode, campaignInfo, setCampaignData, setPaymentModelSelected, setChangedPlanId, setSelectedPlanId, setCoverTypeSelected, selectedPlanId, setShowDetails, setShowDetail, setShowCompareDetail, setPlanSelected, localStorageService, Steps, setPlanSelectedNextStep, setFiltersQuotes, insuranceType, insurance, navigateNext, STEP, setSeeToastAlertNext, setNamePlan), buildDataRowsQuotes = _15.buildDataRowsQuotes, setCoverTypeStorybook = _15.setCoverTypeStorybook, callDispatchPaymentMode = _15.callDispatchPaymentMode, callDispatchPlan = _15.callDispatchPlan, updateCoverPrice = _15.updateCoverPrice, clickChangePaymentMode = _15.clickChangePaymentMode, clickDetails = _15.clickDetails, clickCompareDetails = _15.clickCompareDetails, savePlan = _15.savePlan, onClickSelectRowQuote = _15.onClickSelectRowQuote, clickCard = _15.clickCard, clickAcquire = _15.clickAcquire, onClickNext = _15.onClickNext, handleCancelSearch = _15.handleCancelSearch;
    useEffect(function () {
        dispatch(plansClearData());
    }, [dispatch]);
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFilters(newMap);
    }, [summary]);
    /* Mapeo de polizas y cotizaciones*/
    useEffect(function () {
        if (responseAllQuote) {
            /*Build Filter Quotes*/
            setFiltersQuotes([
                {
                    label: insuranceType,
                    name: "Tipo de Seguro",
                    type: "label",
                },
                {
                    label: insurance,
                    name: "Seguro",
                    type: "label",
                },
                {
                    label: planSelectedNextStep.name,
                    name: "Plan",
                    type: "label",
                },
                {
                    label: campaignInfo ? campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo["0"].name : "",
                    name: "Campaña",
                    type: "label",
                },
            ]);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseAllQuote)) {
            buildDataRowsQuotes(responseAllQuote);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        callDispatchPaymentMode();
        // callDispatchCatalog();
    }, []);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (responseTravelPremiums && responseTravelPremiums.data) {
            // Update plan prices with travel premiums
            if (plan.data && plan.data.length > 0) {
                var updatedPlans = plan.data.map(function (planItem) {
                    var _a;
                    // Find matching premium data by planCode
                    var premiumData = responseTravelPremiums.data.find(function (premium) { return premium.planCode === planItem.code; });
                    if (premiumData && premiumData.premiums) {
                        // Calculate total premium by summing all age ranges
                        var totalPremium = premiumData.premiums.reduce(function (sum, range) { return sum + (range.premium || 0); }, 0);
                        // Update scenaries with premium prices
                        var updatedScenaries = (_a = planItem.scenaries) === null || _a === void 0 ? void 0 : _a.map(function (scenario) {
                            // Find matching premium by range
                            var premiumForRange = null;
                            var order = 0;
                            if (scenario.name.includes("0 hasta: 20") ||
                                scenario.name.includes("0 - 20")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range0To20"; });
                                order = 0;
                            }
                            else if (scenario.name.includes("21 hasta: 74") ||
                                scenario.name.includes("21 - 74")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range21To74"; });
                                order = 1;
                            }
                            else if (scenario.name.includes("75 hasta: 85") ||
                                scenario.name.includes("75 - 85")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range75To85"; });
                                order = 2;
                            }
                            return __assign(__assign({}, scenario), { price: premiumForRange
                                    ? premiumForRange.premium.toFixed(2)
                                    : scenario.price, order: order });
                        }).sort(function (a, b) { return a.order - b.order; });
                        return __assign(__assign({}, planItem), { price: totalPremium.toFixed(2), scenaries: updatedScenaries || planItem.scenaries });
                    }
                    return planItem;
                });
                setPlan(__assign(__assign({}, plan), { data: updatedPlans }));
            }
            dispatch(travelPremiumsClearData());
        }
        if (errorTravelPremiums) {
            showErrorToast(errorTravelPremiums, setSeeToast, t);
            dispatch(travelPremiumsClearData());
        }
    }, [responseTravelPremiums, errorTravelPremiums]);
    useEffect(function () {
        if (responsePlans && responsePlans.data) {
            //Vamos
            var showTravelPrices = false;
            var dataST_1 = [];
            flags === null || flags === void 0 ? void 0 : flags.forEach(function (actionFlag) {
                if (actionFlag.name === "afy-plan-range-age") {
                    setEnabledAgeRange(actionFlag.value === "true");
                }
                if (actionFlag.name === "afy-show-plan-travel-range-info") {
                    showTravelPrices = true;
                    setEnableShowExtra(true); // Enable showExtraInfo when travel prices are shown
                }
            });
            // Call Travel Premiums API if flag is enabled
            if (showTravelPrices && projectId) {
                // Get date values from localStorage
                var fechaSalidaStr = findParamInLocalStorage("fechaSalida");
                var fechaRegresoStr = findParamInLocalStorage("fechaRegreso");
                // Calculate days between dates
                var days = 0;
                if (fechaSalidaStr && fechaRegresoStr) {
                    // Helper function to parse date from either format
                    var parseDate = function (dateStr) {
                        // Check if date is in ISO/GMT format
                        if (dateStr.includes("GMT") ||
                            dateStr.includes("T") ||
                            (dateStr.includes("-") && !dateStr.includes("/"))) {
                            return new Date(dateStr);
                        }
                        else if (dateStr.includes("/")) {
                            // DD/MM/YYYY format
                            var _a = dateStr.split("/"), dia = _a[0], mes = _a[1], anio = _a[2];
                            return new Date(parseInt(anio), parseInt(mes) - 1, parseInt(dia));
                        }
                        else {
                            // Fallback: try to parse as-is
                            return new Date(dateStr);
                        }
                    };
                    var fechaSalida = parseDate(fechaSalidaStr);
                    var fechaRegreso = parseDate(fechaRegresoStr);
                    // Validate that dates are valid
                    if (!isNaN(fechaSalida.getTime()) && !isNaN(fechaRegreso.getTime())) {
                        // Calculate difference in days
                        var diffTime = Math.abs(fechaRegreso.getTime() - fechaSalida.getTime());
                        days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    }
                    else {
                        console.error("Invalid dates:", {
                            fechaSalidaStr: fechaSalidaStr,
                            fechaRegresoStr: fechaRegresoStr,
                        });
                    }
                }
                // Get age range values from localStorage
                var edad020 = parseInt(findParamInLocalStorage("edad020")) || 0;
                var edad2174 = parseInt(findParamInLocalStorage("edad2174")) || 0;
                var edad7585 = parseInt(findParamInLocalStorage("edad7585")) || 0;
                var travelPremiumsBody = {
                    data: {
                        fkProjectId: projectId,
                        days: days,
                        range0To20: edad020,
                        range21To74: edad2174,
                        range75To85: edad7585,
                    },
                };
                dispatch(travelPremiums(travelPremiumsBody));
            }
            responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.data.map(function (item) {
                var _a, _b, _c;
                if ((((_a = item === null || item === void 0 ? void 0 : item.price) === null || _a === void 0 ? void 0 : _a.amount) !== "0.00" && ((_b = item === null || item === void 0 ? void 0 : item.price) === null || _b === void 0 ? void 0 : _b.amount) !== "0") ||
                    showTravelPrices) {
                    dataST_1.push({
                        id: item.id,
                        name: item.name ? item.name.replace(/"/g, "") : "",
                        logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                        backgroundColor: "#ffffff",
                        currency: "RD$",
                        itemsValue: [],
                        option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                        period: paymentModelSelected.name,
                        benefits: item.benefits,
                        scenaries: item.scenaries,
                        code: item.code,
                        //price: Array.isArray(item.scenaries) ? item.scenaries[0].price : "0",
                        price: ((_c = item === null || item === void 0 ? void 0 : item.price) === null || _c === void 0 ? void 0 : _c.amount) ? item.price.amount : "0",
                        textColor: "#3A56A1",
                    });
                }
            });
            setPlan(__assign(__assign({}, plan), { data: dataST_1 }));
            if (responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.pagingInfo) {
                setCountPagination(responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.pagingInfo.totalItems);
            }
            dispatch(plansClearData());
        }
    }, [responsePlans]);
    useEffect(function () {
        var _a;
        if (responsePaymentMode && responsePaymentMode.data) {
            var data = responsePaymentMode;
            var result = (_a = data.data) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                var _a;
                return {
                    id: x.catalogPaymentMode.id,
                    label: x.catalogPaymentMode.description,
                    name: x.catalogPaymentMode.description,
                    default: ((_a = x.catalogPaymentMode.description) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "mensual",
                };
            });
            if (result && result.length > 0) {
                var mensual = result.find(function (x) { return x.default === true; });
                if (mensual) {
                    setPaymentModelSelected(mensual);
                }
                else {
                    setPaymentModelSelected(result[0]);
                }
                var ms = setPaymentModeData(null, result);
                setPaymentMode(ms);
            }
        }
    }, [responsePaymentMode]);
    useEffect(function () {
        if (paymentModelSelected.id && !isInitialLoad) {
            callDispatchPlan();
        }
    }, [paymentModelSelected]);
    useEffect(function () {
        if (coverTypeSelected && coverTypeSelected.id) {
            updateCoverPrice(planSelected, coverTypeSelected);
        }
    }, [coverTypeSelected]);
    useEffect(function () {
        if (namePlan) {
            callDispatchPlan();
        }
    }, [namePlan]);
    useEffect(function () {
        var isMounted = true;
        var callPlan = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isMounted && paymentModelSelected.id) {
                    callDispatchPlan();
                    setIsInitialLoad(false);
                }
                return [2 /*return*/];
            });
        }); };
        callPlan();
        return function () {
            isMounted = false;
        };
    }, [planPage, planLimit, paymentModelSelected.id]);
    return (_jsxs(_Fragment, { children: [_jsx(PlansHeader, { loading: loadingPlans || updating || loadingTravelPremiums, seeToast: seeToast, setSeeToast: setSeeToast, seeToastAlertNext: seeToastAlertNext, setSeeToastAlertNext: setSeeToastAlertNext, breadCrumbs: breadCrumbs, steps: stepsData, title: plan.titlePage }), _jsx(PagesHeader, { titlePage: "Detalle del plan", hideStep: false, steps: steps }), paymentMode && paymentMode.length > 0 && (_jsx(PlanView, { error: error, helperText: helperText, planSelected: planSelected, paymentMode: paymentMode, campaignInfo: campaignInfo, listIdentificationType: [], showDetail: showDetail, showCompareDetail: showCompareDetail, closeDetail: closeDetail, plan: plan, breadCrumbs: breadCrumbs, clickDetails: clickDetails, clickCompareDetail: clickCompareDetails, onClickCompareItem: function () { }, clickChangePaymentMode: clickChangePaymentMode, searchFilter: searchFilter, clickView: clickView, clickCard: clickCard, steps: stepsData, onClickAcquire: clickAcquire, clickChip: function () { }, onClickNext: function () { }, onClickBack: onClickBack, extraInfoNames: extraInfoNames, insurance: insurance, insuranceType: insuranceType, showExtraInfo: enableAgeRange || enableShowExtra, showQuotes: showModalQuotes, onCloseModalQuote: onCloseModalQuotes, filtersQuote: filtersQuotes, rowsQuote: rowsQuotes, onClickSelectRowQuote: onClickSelectRowQuote, onClickNewQuote: onClickNewQuoteModal, filterTitleInsuranceInformation: "Información", showInformation: false, onCancelSearch: handleCancelSearch, insurancePage: planPage, insuranceLimit: planLimit, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, filters: filters }))] }));
};
export default Plan;
